import { i18n } from '../custom/translator.js';
i18n.setGlobalData({
  year: new Date().getFullYear(),
});
import '../custom/CustomHeader.js';
import '../custom/UserHeader.js';
import '../custom/CampaignSlider.js';
import '../custom/CampaignGrid.js';
import '../custom/CustomFooter.js';
import '../custom/Skeleton.js';
import { loadCampaignPrograms, loadCountries, loadLangList } from './common.js';
$('document').ready(function () {
  //initCampScroll();
});

export function createSkeletons(template, count = 2, container) {
  const references = [];
  for (let i = 0; i < count; i++) {
    const clone = template.content.cloneNode(true);
    const skeleton = clone.querySelector('custom-skeleton');

    skeleton.classList.add('page-placeholder'); //marked as temporary

    references.push(skeleton);
    container.appendChild(clone);
  }
  return references;
}

export function addSkeleton(templateNode, container) {
  const clone = templateNode.content.cloneNode(true);
  const newCard = clone.querySelector('custom-skeleton');
  container.appendChild(clone);
  //return [clone, newCard];
  return newCard;
}
export function removeExtraSkeletons(container) {
  const leftoverSkeletons = container.querySelectorAll(
    'custom-skeleton.page-placeholder',
  );
  leftoverSkeletons.forEach((skeleton) => {
    skeleton.remove();
  });
}

export function getAvailableSkeleton(key, container, template) {
  let existingCard = document.getElementById(key);
  if (existingCard) {
    return existingCard;
  }

  let availableSkeleton = container.querySelector(
    'custom-skeleton.page-placeholder',
  );

  if (availableSkeleton) {
    availableSkeleton.classList.remove('page-placeholder');

    return availableSkeleton;
  } else {
    return addSkeleton(template, container);
  }
}

export function displayStars(container, score) {
  //const container = document.getElementById("star-container");

  // 1. Get the numeric rating from data attribute and round it
  const rating = Math.round(
    parseFloat(score || container.getAttribute('data-rating')),
  );
  const maxStars = 5;

  // 2. Generate filled and empty star strings using .repeat()
  const filledStars = '★'.repeat(rating);
  const emptyStars = '☆'.repeat(maxStars - rating);

  // 3. Inject the complete star string into the element
  container.innerHTML = filledStars + emptyStars;
}

export function getStars(rating) {
  console.log('rating: ', rating);

  const ratingNum = Math.round(parseFloat(rating));
  const maxStars = 5;

  // 2. Generate filled and empty star strings using .repeat()
  const filledStars = '★'.repeat(rating);
  const emptyStars = '☆'.repeat(maxStars - rating);
  return filledStars + emptyStars;
}

// export function initCampScroll() {
//   const container = document.getElementById('campaignSlider');
//   const leftArrow = document.getElementById('navLeft');
//   const rightArrow = document.getElementById('navRight');
//   if (!container || !leftArrow || !rightArrow) {
//     return;
//   }
//   const scrollAmount = 320;

//   // Attach click events safely inside JavaScript
//   leftArrow.addEventListener('click', () => {
//     container.scrollBy({
//       left: -scrollAmount,
//       behavior: 'smooth',
//     });
//   });

//   rightArrow.addEventListener('click', () => {
//     container.scrollBy({
//       left: scrollAmount,
//       behavior: 'smooth',
//     });
//   });
// }

// app.js

function setupGlobalCampaignListeners() {
  document.body.addEventListener('click', (event) => {
    // 1. Use composedPath() to find the real clicked element, even inside a Shadow DOM
    const path = event.composedPath();

    // Find if any element in the click path has the zeffy-form-link attribute
    const targetButton = path.find(
      (element) =>
        element.hasAttribute && element.hasAttribute('zeffy-form-link'),
    );

    // If no zeffy link was clicked, exit immediately
    if (!targetButton) return;

    // Stop any alternative behaviors or duplicate listener leaks
    event.preventDefault();
    event.stopPropagation();

    // 2. Fetch the current language-localized link variant from the active element
    const activeZeffyUrl = targetButton.getAttribute('zeffy-form-link');
    if (!activeZeffyUrl) return;

    // 3. Render your custom modal wrapper layout cleanly
    let zeffyModal = document.getElementById('zeffy-modal-container');

    if (!zeffyModal) {
      zeffyModal = document.createElement('div');
      zeffyModal.id = 'zeffy-modal-container';

      Object.assign(zeffyModal.style, {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: '99999',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      });

      const modalWrapper = document.createElement('div');
      Object.assign(modalWrapper.style, {
        position: 'relative',
        width: '500px',
        height: '85vh',
      });

      const closeBtn = document.createElement('button');
      closeBtn.innerHTML = '&times;';
      closeBtn.setAttribute('aria-label', 'Close donation modal');

      Object.assign(closeBtn.style, {
        position: 'absolute',
        top: '-40px',
        right: '0',
        background: 'none',
        border: 'none',
        color: '#ffffff',
        fontSize: '36px',
        cursor: 'pointer',
        lineHeight: '1',
        padding: '5px',
      });

      closeBtn.addEventListener('click', () => zeffyModal.remove());

      const iframe = document.createElement('iframe');
      iframe.src = activeZeffyUrl;
      iframe.title = 'Zeffy Donation Form';

      Object.assign(iframe.style, {
        width: '100%',
        height: '100%',
        border: 'none',
        borderRadius: '12px',
        backgroundColor: '#fff',
        boxShadow: '0px 10px 30px rgba(0,0,0,0.3)',
      });

      zeffyModal.addEventListener('click', (e) => {
        if (e.target === zeffyModal) zeffyModal.remove();
      });

      modalWrapper.appendChild(closeBtn);
      modalWrapper.appendChild(iframe);
      zeffyModal.appendChild(modalWrapper);
      document.body.appendChild(zeffyModal);
    }
  });
}

export function getLanguage() {
  return (
    localStorage.getItem('preferredLanguage') || navigator.language.slice(0, 2)
  );
}

export function stopContentLoading() {
  const activeBones = document.querySelectorAll('.shimmer-bone');
  activeBones.forEach((bone) => {
    bone.classList.remove('shimmer-bone', 'is-circle');
  });
}

function initCountries() {
  const countriesSelect = document.querySelectorAll(
    'select[load-country="true"]',
  );
  if (!countriesSelect) return;
  const lang = getLanguage();
  countriesSelect.forEach((element) => {
    loadCountries(lang, element);
  });
}

function initLanguages() {
  const languagesSelect = document.querySelectorAll(
    'select[load-language="true"]',
  );
  if (!languagesSelect) return;
  const lang = getLanguage();
  languagesSelect.forEach((element) => {
    loadLangList(lang, element);
  });
}

function initCampaignPrograms() {
  const campaignSelect = document.querySelectorAll(
    'select[load-campaign="true"]',
  );
  if (!campaignSelect) return;
  campaignSelect.forEach((element) => {
    loadCampaignPrograms(element);
    i18n.translatePage(element);
  });
}

// Initialize the global campaign link click framework loop
setupGlobalCampaignListeners();
initCountries();
initLanguages();
initCampaignPrograms();
